import {
  AutomatedActions,
  AutomatedActionsSelectionType,
  AutomationErrorStateType,
  AutomationFlowJourneySteps,
  AutomationStateType,
  PerformedActionsOptions
} from 'src/lib/types/automations'
import { CartConditionOptions, PurchaseOptions } from 'src/lib/types/common/cartConditions'
import { CustomerEligibilityOptions } from 'src/lib/types/common/customerConditions'
import { JourneyLineStepType } from 'src/lib/types/common/journeyLine'
import { RadioItemConfigType, SwitchableTabType } from 'src/lib/types/random'

export const initialAutomationErrorState: AutomationErrorStateType = {
  title: {
    status: false
  },
  automatedAction: {
    paymentMethodIds: {
      status: false
    }
  },
  performedAction: {
    appliedDiscounts: {
      status: false
    }
  },
  cartConditions: {
    type: PurchaseOptions.ENTIRE_CART,
    minimumValue: {
      status: false
    },
    maximumValue: {
      status: false
    }
  },
  customerEligibility: {
    type: CustomerEligibilityOptions.LIFETIME_ORDER_COUNT,
    minimumOrders: {
      status: false
    },
    maximumOrders: {
      status: false
    }
  },
  activePeriod: {
    startDate: {
      status: false
    },
    endDate: {
      status: false
    }
  }
}

export const initialAutomationFlowState: AutomationStateType = {
  title: '',
  description: '',
  automatedAction: {
    type: AutomatedActions.HIDE_PAYMENT_MODES,
    paymentMethodIds: []
  },
  performedAction: {
    type: PerformedActionsOptions.NO_CONDITIONS
  },
  journeyStep: AutomationFlowJourneySteps.SETUP,
  cartConditions: {
    type: CartConditionOptions.NO_CONDITIONS
  },
  customerEligibility: {
    type: CustomerEligibilityOptions.ALL_CUSTOMERS
  },
  activePeriod: {
    startDate: new Date(),
    endDateEnabled: false
  },
  isActive: false,
  errorState: initialAutomationErrorState
}

export const journeyLineConfig: JourneyLineStepType[] = [
  {
    label: 'Setup',
    step: AutomationFlowJourneySteps.SETUP
  },
  {
    label: 'Cart condition',
    step: AutomationFlowJourneySteps.CART_CONDITIONS
  },
  {
    label: 'Customer eligibility',
    step: AutomationFlowJourneySteps.CUSTOMER_ELIGIBILITY
  },
  {
    label: 'Usage limits',
    step: AutomationFlowJourneySteps.USAGE_LIMITS
  }
]

export const automatedActionsSelection: AutomatedActionsSelectionType[] = [
  {
    label: 'Hide payment methods',
    value: AutomatedActions.HIDE_PAYMENT_MODES
  },
  {
    label: 'Disable rewards',
    value: AutomatedActions.DISABLE_REWARDS
  }
]

export const performedActionSelection: RadioItemConfigType[] = [
  {
    label: 'No conditions',
    valueType: PerformedActionsOptions.NO_CONDITIONS
  },
  {
    label: 'When customer is redeeming rewards',
    valueType: PerformedActionsOptions.REDEEM_REWARDS
  },
  {
    label: 'When customer applied specific discounts',
    valueType: PerformedActionsOptions.APPLY_DISCOUNTS
  }
]

export const automationsTabList: SwitchableTabType[] = [
  {
    id: 'tab-create-automation',
    isActive: true,
    label: 'Create automations',
    name: 'CREATE_AUTOMATIONS',
    childComponent: 'CreateAutomationsTab'
  },
  {
    id: 'tab-view-automation',
    isActive: false,
    label: 'View automations',
    name: 'VIEW_AUTOMATIONS',
    childComponent: 'ViewAutomationsTab'
  }
]
